<template>
<div class="popup-panel" @mousedown="onMouseDown">
  <div class="popup-header" v-if="titleVisible">
    <div class="popup-title-wrapper">{{title}}</div>
    <el-button :class="$style['close-btn']" size="small" type="no-border" @click="closeBtnClick"><i class="far fa-times"></i></el-button>
  </div>
  <div class="popup-contents" :style="titleVisible ? 'height: calc(100% - 50px)' : 'height: 100%'">
    <slot></slot>
  </div>
</div>
</template>

<script>
import MapConst from '@/constants/topologymap';

import { MapPopup } from '@/views/topologymap/js/maps';

export default {
  name: 'WMapPopup',
  props: {
    /**
     * 팝업 타이틀
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * 타이틀 표현 여부
     */
    titleVisible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    /**
     * 모달 팝업인지 반환한다.
     * @author KangBonghun(toto1323)
     * @return {Boolean} 모달팝업이면 true, 아니면 flase
     */
    isModal() {
      return this.$parent.config.type === MapConst.POPUP_TYPE.MODAL;
    },
  },
  created() {
    // 모달팝업이면 ESC 키로 닫을 수 있도록 이벤트 리스너 등록
    if (this.isModal) {
      window.addEventListener('keyup', this.onKeyUp);
    }
  },
  mounted() {
    // 모달팝업이면 헤더에 이동 커서 표시되지 않도록 변경
    if (this.isModal) {
      this.$el.querySelector('.popup-header').style.cursor = 'Default';
    }
  },
  beforeDestroy() {
    // 모달팝업이면 등록 된 키보드리스너 삭제
    if (this.isModal) {
      window.removeEventListener('keyup', this.onKeyUp);
    }
  },
  methods: {
    /**
     * 키업 이벤트
     * @author KangBonghun(toto1323)
     * @param  {[type]} evt [description]
     * @return {[type]}     [description]
     */
    onKeyUp(evt) {
      // ESC 키이면 팝업을 닫는다.
      if (evt.keyCode === 27) {
        this.closeBtnClick();
      }
    },
    /**
     * 헤더에 닫기 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    closeBtnClick() {
      MapPopup.closeAndHide(this.$parent.$options.name);
    },
    /**
     * 팝업을 선택하면 Z-index 값을 조정해서 선택한 팝업이 제일 위로 올라오도록한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onMouseDown() {
      MapPopup.reorderIndex(this.$parent.$options.name);
    },
  },
};
</script>

<style scoped>
.popup-panel {
  height: 100%;
  padding: 0px 15px 15px 15px;
  border-top: 3px solid #5b739f;
}

.popup-header {
  border-bottom: 1px dotted #bbb; /* $linegray */
  cursor: move;
  height: 45px;
  color: #505f9d;
  font-weight: 700;
  font-size: 15px;
  position: absolute;
  width: calc(100% - 30px);
  line-height: 45px;
}
.popup-header:after {
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  top: 42px;
  left: 0px;
  height: 1px;
  border-bottom: 1px dotted #bbb; /* $linegray */
}

.popup-title-wrapper {
  font-weight: bold;
  position: absolute !important;
}

.popup-contents {
  margin-top: 55px;
  overflow-y: auto;
  padding: 0px 1px;
}
</style>

<style module>
.close-btn {
  position: absolute;
  right: 0px;
  top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/MapPopup.vue